import { createZodDto } from 'nestjs-zod';
import { z } from 'zod';

export const updateFormulaScriptDto = z.object({
  script: z.string(),
});

export class UpdateFormulaScriptDto extends createZodDto(
  updateFormulaScriptDto,
) {}
